module.exports = __webpack_public_path__ + "img/journal.a160b3ea.svg";